// extracted by mini-css-extract-plugin
export var slogan = "large-slogan-module--slogan--y7GGr";